/* =========================================================
   MONTEM — motion layer v1  (upload to /assets)
   Enhances existing montem-* sections in place and drives
   the montem-reel section. Respects prefers-reduced-motion.
   ========================================================= */
(function () {
  'use strict';
  if (window.__montemMotion) return;
  window.__montemMotion = true;

  var d = document, root = d.documentElement;
  var cfg = window.MONTEM_MOTION || {};
  var GLOBAL = cfg.global === true;           // set by the "Montem motion" section
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var vw = window.innerWidth, vh = window.innerHeight;
  var scrollY = window.scrollY, lastY = scrollY, velocity = 0;
  var START = window.__mmStart || 120;        // ms; longer when the intro curtain plays

  var heroes = [], cards = [], quotes = [], strips = [], reels = [];
  var bar = null, counter = null, cursor = null;
  var EXPOSURES = parseInt(cfg.exposures, 10) || 36;

  if (GLOBAL) root.classList.add('mm-js');

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function pad(n, w) { n = String(n); while (n.length < (w || 2)) n = '0' + n; return n; }
  function el(tag, cls, html) {
    var e = d.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function deco(e) { e.setAttribute('aria-hidden', 'true'); return e; }

  /* Wrap each word (and any inline element, e.g. the wine accent) in a mask */
  function splitWords(node) {
    if (node.dataset.mmSplit) return $$('.mm-w', node);
    node.dataset.mmSplit = '1';
    var words = [];
    Array.prototype.slice.call(node.childNodes).forEach(function (k) {
      if (k.nodeType === 3) {
        var frag = d.createDocumentFragment();
        k.textContent.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(' ')); return; }
          var m = el('span', 'mm-m'), w = el('span', 'mm-w');
          w.textContent = p; m.appendChild(w); frag.appendChild(m); words.push(w);
        });
        node.replaceChild(frag, k);
      } else if (k.nodeType === 1 && k.tagName !== 'BR') {
        var m = el('span', 'mm-m'), w = el('span', 'mm-w');
        node.replaceChild(m, k); w.appendChild(k); m.appendChild(w); words.push(w);
      }
    });
    words.forEach(function (w, i) { w.style.setProperty('--i', i); });
    return words;
  }

  /* Space Mono "decode" for eyebrows */
  var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/·—';
  function scramble(node) {
    if (node.dataset.mmScr) return;
    node.dataset.mmScr = '1';
    var final = node.textContent, len = final.length, t0 = null;
    var dur = Math.min(1400, 300 + len * 28);
    function frame(t) {
      if (!t0) t0 = t;
      var p = clamp((t - t0) / dur, 0, 1), settled = Math.floor(p * len), out = '';
      for (var i = 0; i < len; i++) {
        var c = final.charAt(i);
        out += (i < settled || c === ' ') ? c : GLYPHS.charAt((Math.random() * GLYPHS.length) | 0);
      }
      node.textContent = out;
      if (p < 1) requestAnimationFrame(frame); else node.textContent = final;
    }
    requestAnimationFrame(frame);
  }

  /* In-view trigger */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var t = e.target;
      io.unobserve(t);
      t.classList.add('is-in');
      if (t._mmIn) t._mmIn();
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }) : null;

  function watch(t, fn) {
    t._mmIn = fn || null;
    if (reduce || !io) { t.classList.add('is-in'); if (fn) fn(); return; }
    io.observe(t);
  }

  /* ---------- hero ---------- */
  function initHero(hero) {
    if (hero.dataset.mm) return;
    hero.dataset.mm = '1';
    var media = $('.montem-frame, .montem-hero-placeholder', hero);
    var layer = el('div', 'mm-hero-layer');
    if (media) { hero.insertBefore(layer, media); layer.appendChild(media); }

    hero.appendChild(deco(el('div', 'mm-crops', '<i></i><i></i><i></i><i></i>')));
    var meta = deco(el('div', 'mm-hero-meta'));
    meta.appendChild(el('span')).textContent = cfg.coords || '25.6573° N — 100.4022° W';
    if (cfg.altitude) meta.appendChild(el('span')).textContent = cfg.altitude;
    hero.appendChild(meta);
    hero.appendChild(deco(el('div', 'mm-scroll-cue', '<span>Scroll</span><i></i>')));

    var title = $('.montem-hero-title', hero);
    if (title) splitWords(title);
    hero.classList.add('mm-hero');

    var h = { el: hero, layer: layer, content: $('.montem-hero-content', hero), mx: 0, my: 0, tx: 0, ty: 0 };
    heroes.push(h);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add('is-in'); });
    });
    var eyebrow = $('.montem-eyebrow', hero);
    if (eyebrow && !reduce) setTimeout(function () { scramble(eyebrow); }, START);

    if (finePointer && !reduce) {
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        h.tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        h.ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
      });
      hero.addEventListener('pointerleave', function () { h.tx = 0; h.ty = 0; });
    }
  }

  function updateHero(h) {
    var r = h.el.getBoundingClientRect();
    if (r.bottom < 0 || r.top > vh) return;
    var hp = reduce ? 0 : clamp(-r.top / r.height, 0, 1);
    h.mx = lerp(h.mx, h.tx, 0.06);
    h.my = lerp(h.my, h.ty, 0.06);
    h.layer.style.transform = 'translate3d(' + (h.mx * -16).toFixed(2) + 'px,' +
      (hp * r.height * 0.32 + h.my * -12).toFixed(2) + 'px,0)';
    if (h.content) {
      h.content.style.transform = 'translate3d(' + (h.mx * 6).toFixed(2) + 'px,' + (hp * -90 + h.my * 4).toFixed(2) + 'px,0)';
      h.content.style.opacity = clamp(1 - hp * 1.5, 0, 1).toFixed(3);
    }
    h.el.style.setProperty('--mm-hp', hp.toFixed(3));
  }

  /* ---------- gallery cards ---------- */
  function initCards() {
    $$('.montem-gallery-grid').forEach(function (grid) {
      $$('.montem-frame-card', grid).forEach(function (card, i) {
        if (card.dataset.mm) return;
        card.dataset.mm = '1';
        card.classList.add('mm-card');
        card.appendChild(deco(el('div', 'mm-crops mm-crops--card', '<i></i><i></i><i></i><i></i>')));
        card.appendChild(deco(el('div', 'mm-shutter')));
        card.style.setProperty('--mm-d', ((i % 4) * 90) + 'ms');
        if (!reduce) card.classList.add('mm-reveal');
        watch(card);

        var img = $('img', card);
        if (!img) return;
        var c = { el: card, img: img, mx: 0, my: 0, tx: 0, ty: 0 };
        cards.push(c);
        if (finePointer && !reduce) {
          card.addEventListener('pointermove', function (e) {
            var r = card.getBoundingClientRect();
            c.tx = (e.clientX - r.left) / r.width - 0.5;
            c.ty = (e.clientY - r.top) / r.height - 0.5;
          });
          card.addEventListener('pointerleave', function () { c.tx = 0; c.ty = 0; });
        }
      });
    });
  }

  function updateCard(c) {
    if (reduce) return;
    var r = c.el.getBoundingClientRect();
    if (r.bottom < -60 || r.top > vh + 60) return;
    c.mx = lerp(c.mx, c.tx, 0.1);
    c.my = lerp(c.my, c.ty, 0.1);
    var prog = clamp((r.top + r.height / 2 - vh / 2) / vh, -1, 1);
    c.img.style.translate = (c.mx * -8).toFixed(2) + 'px calc(' + (prog * -4).toFixed(2) + '% + ' + (c.my * -8).toFixed(2) + 'px)';
  }

  /* ---------- type ---------- */
  function initText() {
    $$('.montem-heading').forEach(function (h) {
      if (h.dataset.mmT) return;
      h.dataset.mmT = '1';
      splitWords(h);
      if (!reduce) h.classList.add('mm-split');
      watch(h);
    });
    $$('.montem-eyebrow').forEach(function (e) {
      if (e.closest('.montem-hero') || e.dataset.mmE) return;
      e.dataset.mmE = '1';
      watch(e, function () { if (!reduce) scramble(e); });
    });
    $$('.montem-section-sub').forEach(function (s) {
      if (s.dataset.mmF) return;
      s.dataset.mmF = '1';
      if (!reduce) s.classList.add('mm-fade');
      watch(s);
    });
    $$('.montem-quote-text').forEach(function (q) {
      if (q.dataset.mmQ) return;
      q.dataset.mmQ = '1';
      var words = splitWords(q);
      q.classList.add('mm-quote-split');
      q.style.setProperty('--n', words.length);
      quotes.push({ el: q, box: q.closest('.montem-quote') || q });
    });
  }

  function updateQuote(q) {
    if (reduce) { q.el.style.setProperty('--p', 1); return; }
    var r = q.box.getBoundingClientRect();
    if (r.bottom < 0 || r.top > vh) return;
    var p = clamp((vh * 0.92 - r.top) / (vh * 0.62), 0, 1);
    q.el.style.setProperty('--p', p.toFixed(3));
  }

  /* ---------- contact strip → drifting marquee ---------- */
  function initStrip(strip) {
    if (strip.dataset.mm || reduce) return;
    var rail = $('.montem-strip-rail', strip);
    if (!rail) return;
    var frames = $$('.montem-strip-frame', rail);
    if (frames.length < 3) return;
    strip.dataset.mm = '1';
    strip.classList.add('mm-marquee');

    var single = frames.reduce(function (s, f) { return s + f.offsetWidth; }, 0) || 1;
    var reps = Math.max(1, Math.ceil(vw / single));
    for (var k = 1; k < reps * 2; k++) {
      frames.forEach(function (f) {
        var c = f.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.tabIndex = -1;
        rail.appendChild(c);
      });
    }
    var s = { el: strip, rail: rail, unit: single * reps, x: 0, speed: 0.45, dir: 1, hover: false };
    strip.addEventListener('pointerenter', function () { s.hover = true; });
    strip.addEventListener('pointerleave', function () { s.hover = false; });
    strips.push(s);
  }

  function updateStrip(s) {
    var r = s.el.getBoundingClientRect();
    if (r.bottom < 0 || r.top > vh) return;
    if (velocity > 1) s.dir = 1; else if (velocity < -1) s.dir = -1;
    var target = s.hover ? 0 : 0.45 + Math.min(Math.abs(velocity), 40) * 0.12;
    s.speed = lerp(s.speed, target, 0.08);
    s.x -= s.speed * s.dir;
    if (s.x <= -s.unit) s.x += s.unit;
    if (s.x > 0) s.x -= s.unit;
    var skew = s.hover ? 0 : clamp(velocity * 0.2, -5, 5);
    s.rail.style.transform = 'translate3d(' + s.x.toFixed(2) + 'px,0,0) skewX(' + (-skew).toFixed(2) + 'deg)';
  }

  /* ---------- reel (pinned horizontal scroll) ---------- */
  function reelMode() { return !reduce && window.matchMedia('(min-width: 861px)').matches; }

  function initReel(sec) {
    if (sec.dataset.mm) return;
    sec.dataset.mm = '1';
    var r = {
      el: sec,
      sticky: $('.mm-reel__sticky', sec),
      track: $('.mm-reel__track', sec),
      nums: $('.mm-reel__numerals', sec),
      rails: $$('.mm-reel__rail', sec),
      frames: $$('.mm-reel__frame', sec),
      now: $('.mm-reel__count-now', sec),
      bar: $('.mm-reel__bar', sec),
      speed: parseFloat(sec.getAttribute('data-mm-speed')) || 1,
      sp: 0, x: 0, active: -1, items: [], on: false, dist: 0
    };
    reels.push(r);
    measureReel(r);
  }

  function measureReel(r) {
    r.on = reelMode();
    r.el.classList.toggle('is-pinned', r.on);
    if (!r.on) {
      r.el.style.height = '';
      r.track.style.transform = '';
      r.frames.forEach(function (f) { f.style.removeProperty('--f'); });
      return;
    }
    r.dist = Math.max(0, r.track.offsetWidth - r.sticky.clientWidth);
    r.el.style.height = Math.round(r.dist * r.speed + vh) + 'px';
    var base = r.track.getBoundingClientRect().left - r.x;
    r.items = r.frames.map(function (f) {
      return { el: f, center: base + f.offsetLeft + f.offsetWidth / 2 };
    });
  }

  function updateReel(r) {
    if (!r.on) return;
    var rect = r.el.getBoundingClientRect();
    if (rect.bottom < -vh || rect.top > vh * 2) return;
    var total = rect.height - vh;
    var p = total > 0 ? clamp(-rect.top / total, 0, 1) : 0;
    r.sp = lerp(r.sp, p, 0.14);
    r.x = -r.sp * r.dist;
    r.track.style.transform = 'translate3d(' + r.x.toFixed(1) + 'px,0,0)';
    if (r.nums) r.nums.style.transform = 'translate3d(' + (r.x * 0.45).toFixed(1) + 'px,-50%,0)';
    r.rails.forEach(function (rl, k) { rl.style.backgroundPosition = (r.x * (k ? 1.28 : 1.12)).toFixed(1) + 'px 0'; });
    if (r.bar) r.bar.style.setProperty('--p', r.sp.toFixed(4));

    var mid = vw / 2, best = 0, bf = -1;
    for (var i = 0; i < r.items.length; i++) {
      var it = r.items[i];
      var f = 1 - clamp(Math.abs(it.center + r.x - mid) / (vw * 0.55), 0, 1);
      f = f * f * (3 - 2 * f);
      it.el.style.setProperty('--f', f.toFixed(3));
      if (f > bf) { bf = f; best = i; }
    }
    if (best !== r.active && r.items.length) {
      if (r.active > -1 && r.items[r.active]) r.items[r.active].el.classList.remove('is-active');
      r.items[best].el.classList.add('is-active');
      r.active = best;
      if (r.now) r.now.textContent = pad(best + 1);
    }
  }

  /* ---------- chrome: progress line, exposure counter, grain, cursor ---------- */
  function initChrome() {
    if (cfg.grain && !reduce) d.body.appendChild(deco(el('div', 'mm-grain')));
    if (cfg.progress) { bar = deco(el('div', 'mm-progress')); d.body.appendChild(bar); }
    if (cfg.counter) { counter = deco(el('div', 'mm-counter')); d.body.appendChild(counter); }
    if (cfg.cursor && finePointer && !reduce) initCursor();
  }

  function initCursor() {
    var node = deco(el('div', 'mm-cursor', '<span class="mm-cursor__label"></span>'));
    var label = node.firstChild;
    d.body.appendChild(node);
    root.classList.add('mm-has-cursor');
    cursor = { el: node, x: vw / 2, y: vh / 2, tx: vw / 2, ty: vh / 2 };
    var state = '';
    d.addEventListener('pointermove', function (e) {
      cursor.tx = e.clientX; cursor.ty = e.clientY;
      var t = e.target, next = 'is-visible';
      if (t && t.closest) {
        var card = t.closest('.mm-card, .mm-reel__frame');
        if (t.closest('button, .montem-add-dot, input, select, textarea, label')) next += ' is-link';
        else if (card && t.closest('.montem-frame-link, .mm-reel__media')) {
          next += ' is-label';
          var no = card.querySelector('.montem-fno');
          var txt = 'View' + (no ? ' — ' + no.textContent.trim() : '');
          if (label.textContent !== txt) label.textContent = txt;
        } else if (t.closest('a, [role="button"]')) next += ' is-link';
      }
      if (next !== state) { node.className = 'mm-cursor ' + next; state = next; }
    }, { passive: true });
    root.addEventListener('pointerleave', function () { node.className = 'mm-cursor'; state = ''; });
  }

  function updateChrome() {
    var max = root.scrollHeight - vh;
    var p = max > 0 ? clamp(scrollY / max, 0, 1) : 0;
    if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    if (counter) {
      var fr = 1 + Math.round(p * (EXPOSURES - 1));
      if (counter._fr !== fr) {
        counter._fr = fr;
        counter.innerHTML = 'FR <b>' + pad(fr) + '</b> / ' + pad(EXPOSURES);
      }
      counter.classList.toggle('is-visible', scrollY > 60);
    }
    if (cursor) {
      cursor.x = lerp(cursor.x, cursor.tx, 0.22);
      cursor.y = lerp(cursor.y, cursor.ty, 0.22);
      cursor.el.style.transform = 'translate3d(' + cursor.x.toFixed(1) + 'px,' + cursor.y.toFixed(1) + 'px,0)';
    }
  }

  /* ---------- loop ---------- */
  function loop() {
    scrollY = window.scrollY;
    velocity = lerp(velocity, scrollY - lastY, 0.2);
    lastY = scrollY;
    if (GLOBAL) {
      updateChrome();
      heroes.forEach(updateHero);
      cards.forEach(updateCard);
      quotes.forEach(updateQuote);
      strips.forEach(updateStrip);
    }
    reels.forEach(updateReel);
    requestAnimationFrame(loop);
  }

  function scan() {
    if (GLOBAL) {
      $$('.montem-hero').forEach(initHero);
      initCards();
      initText();
      $$('.montem-strip').forEach(initStrip);
    }
    $$('[data-mm-reel]').forEach(initReel);
  }

  var resizeT;
  function onResize() {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () {
      vw = window.innerWidth; vh = window.innerHeight;
      reels.forEach(measureReel);
    }, 120);
  }

  function boot() {
    if (GLOBAL) initChrome();
    scan();
    requestAnimationFrame(loop);
    window.addEventListener('resize', onResize);
    window.addEventListener('load', function () { reels.forEach(measureReel); });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(onResize);
      reels.forEach(function (r) { ro.observe(r.track); });
    }
    /* theme editor: re-run on section add / reorder */
    d.addEventListener('shopify:section:load', function () { scan(); reels.forEach(measureReel); });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
